import { useState, useCallback, useEffect } from "react";

// react router dom
import { useNavigate } from "react-router-dom";

// state
import { getUsers } from "../../../services/apis/user";
import { useAppDispatch } from "../../..//store";

interface OpenDType {
  [key: string]: any;
}

const useHome = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState<number>(1);
  const [visible, setVisible] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openD, setOpenD] = useState<OpenDType>({});

  const onCloseModal = (): void => {
    setVisible(false);
  };

  const onOpen = (d: any): void => {
    setOpen(true);
    setOpenD(d);
  };

  const onCloseOpenModal = (): void => {
    setOpen(false);
  };

  const onLoad = useCallback((): void => {
    getUsers(dispatch, navigate, page);
  }, [dispatch, navigate, page]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return {
    page,
    setPage,
    openD,
    setOpenD,
    setOpen,
    onOpen,
    onCloseOpenModal,
    visible,
    open,
    setVisible,
    onCloseModal,
  };
};

export default useHome;
